import { Component, Input } from '@angular/core';
import { Alert } from '../../interfaces/alert';

@Component({
    selector: 'app-alerts',
    templateUrl: './alerts.component.html',
    styleUrls: ['./alerts.component.scss'],
    standalone: false
})
export class AlertsComponent {
  @Input()
  public alerts!: Alert[];

  @Input()
  public borderTop!: boolean;
}
